import React from "react";
import RoleProgress from "../../progressBar/RoleProgress";
import { createRole } from "../../../sdk/users/modules";
import { X } from "lucide-react";

const FinishPermissions = ({
  id,
  closeReviewPermissionsModal,
  reviewPermissionsModalOpen,
  openPermissionsModal,
  roleName,
  roleDescription,
  selectedPermissions,
  modules,
  fetchRoles,
  setAddRoleSuccessOpen,
  openModal,
  logAudit,
}) => {
  const handleCreateRole = async () => {
    try {
      const response = await createRole(
        roleName,
        roleDescription,
        selectedPermissions,
      );

      if (response?.statusCode === 201) {
        closeReviewPermissionsModal();
        fetchRoles();
        setAddRoleSuccessOpen(true);

        logAudit({
          category: "User Management",
          actionCode: "CREATE_ROLE",
          description: `Created role (${roleName})`,
          page: "User Management",
          tab: "Roles & Permissions",
          section: "Roles",
          metadata: {
            route: "/dashboard/user-management/roles",
            roleName,
          },
        });

        setTimeout(() => {
          setAddRoleSuccessOpen(false);
        }, 2000);
      }
    } catch (error) {
      logAudit({
        category: "User Management",
        actionCode: "CREATE_ROLE_FAILED",
        description: `Failed to create role (${roleName})`,
        page: "User Management",
        tab: "Roles & Permissions",
        section: "Roles",
        metadata: {
          route: "/dashboard/user-management/roles",
          roleName,
          error: error?.message || "Error creating role",
        },
      });

      console.error("Error creating role:", error);
    }
  };

  const handleBackButtonClick = () => {
    closeReviewPermissionsModal();
    openPermissionsModal();
  };

  const handleEditButton = () => {
    closeReviewPermissionsModal();
    openModal();
  };
  return (
    <div
      id={id}
      className={`${
        reviewPermissionsModalOpen ? "flex" : "hidden"
      } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
    >
      <div className="relative rounded-[10px] flex h-[600px] w-[1080px] bg-white shadow">
        <div
          onClick={closeReviewPermissionsModal}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="flex-col flex w-full mx-auto">
          <div className="flex h-full">
            <div className=" w-[28%] p-[20px] rounded-[10px] bg-[#F5F6F7]">
              <div className="rounded-t">
                <p className="text-[20px] font-bold text-[#000] mb-[15px]">
                  Create a new role
                </p>
              </div>
              <div>
                <RoleProgress step={4} />
              </div>
            </div>
            <div className="w-[72%] mx-[10px] flex flex-col mt-5 justify-between">
              <div className="h-[85%] w-[95%]">
                <div className="mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Review and finish
                  </p>
                  <div className="text-[#000] mt-2 text-sm font-normal">
                    <p>
                      Great work! You've provided all the necessary details for
                      the new user. Take a moment to review and confirm the
                      settings below:
                    </p>
                  </div>
                </div>
                <div className="flex justify-between w-[100%] mt-3">
                  <div className="w-[50%]">
                    <p className="text-[#000000] text-[16px] font-[500]">
                      Role Name
                    </p>
                    <p className="text-[#4F4F4F]">{roleName}</p>
                    <p
                      onClick={handleEditButton}
                      className="text-[#157D93] text-[14px] font-[400] cursor-pointer"
                    >
                      Edit
                    </p>
                  </div>
                  <div className="w-[50%]">
                    <p className="text-[#000000] text-[16px] font-[500]">
                      Role description
                    </p>
                    <p className="text-[#4F4F4F]">{roleDescription}</p>
                    <p
                      onClick={handleEditButton}
                      className="text-[#157D93] text-[14px] font-[400] cursor-pointer"
                    >
                      Edit
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-2 justify-between mt-5">
                  <div className="w-full flex items-center justify-between">
                    <p>Permissions({selectedPermissions?.length})</p>
                    <p
                      onClick={handleBackButtonClick}
                      className="text-[#157D93] text-[14px] font-[400] cursor-pointer"
                    >
                      Edit
                    </p>
                  </div>
                  <div className="h-[300px] w-[100%] border-[1px] border-[#000000] p-3 overflow-y-auto">
                    {modules &&
                      modules?.map((module) => {
                        // Filter only selected permissions in this module
                        const selectedPerms = module?.permissions?.filter(
                          (perm) => selectedPermissions?.includes(perm?.id),
                        );

                        // Do not show module if it has no selected permissions
                        if (selectedPerms?.length === 0) return null;

                        return (
                          <div key={module?.id} className="mb-4">
                            {/* Module name */}
                            <p className="text-[#000] font-bold">
                              {module?.name}
                            </p>

                            {/* Only selected permissions */}
                            {selectedPerms?.map((permission) => (
                              <div
                                key={permission.id}
                                className="flex items-center mt-3"
                              >
                                <div className="w-[75%] mb-3">
                                  <p>{permission?.name}</p>
                                </div>
                                <div className="w-[25%] flex items-center justify-end mb-3">
                                  <input
                                    type="checkbox"
                                    className="custom-checkbox"
                                    readOnly
                                    checked={true}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="flex h-[15%] w-[95%] items-center justify-between">
                <div className="flex items-center gap-[20px] w-[15vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleCreateRole}
                    data-modal-toggle={id}
                    type="button"
                    className="text-white bg-[#074073] hover:bg-[#074073] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Finish
                  </button>
                </div>
                <button
                  onClick={closeReviewPermissionsModal}
                  data-modal-toggle={id}
                  type="button"
                  className="text-gray-500 bg-[#D9D9D9] hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-[5px] border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinishPermissions;
